/**
 * Generates PixiJS Textures from pixel matrix data using HTML Canvas 2D.
 * Arcade pixel art style: 16-color NES-inspired palette, 8px blocks.
 */

import { Texture } from 'pixi.js';

export const ARCADE_PALETTE: string[] = [
  '#000000', // 0: black
  '#ffffff', // 1: white
  '#ff0044', // 2: red
  '#44ff00', // 3: green
  '#0044ff', // 4: blue
  '#ffff00', // 5: yellow
  '#00ffff', // 6: cyan
  '#ff00ff', // 7: magenta
  '#884400', // 8: brown
  '#ff8844', // 9: orange
  '#44ff88', // 10: light green
  '#8888ff', // 11: light blue
  '#ff88ff', // 12: pink
  '#ffff88', // 13: light yellow
  '#444444', // 14: dark gray
  '#888888', // 15: light gray
];

export function generatePixelTexture(
  pixels: number[][],
  pixelSize: number = 8,
): Texture {
  const rows = pixels.length;
  const cols = pixels[0].length;
  const canvas = document.createElement('canvas');
  canvas.width = cols * pixelSize;
  canvas.height = rows * pixelSize;

  const ctx = canvas.getContext('2d')!;

  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      const colorIndex = pixels[r][c];
      if (colorIndex === 0) continue; // skip black (transparent)
      ctx.fillStyle = ARCADE_PALETTE[colorIndex];
      ctx.fillRect(c * pixelSize, r * pixelSize, pixelSize, pixelSize);
    }
  }

  return Texture.from(canvas);
}
